module.exports = __webpack_public_path__ + "img/close.464de7a0.svg";